import { Component, createRef } from 'react';
import '../pages.scss';
import {
  DataGrid,
  Column,
  Editing,
  Scrolling,
  Selection,
  SearchPanel,
  Grouping,
  GroupPanel,
  Button,
  HeaderFilter,
  Search,
  ColumnChooser,
  FilterRow,
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { Popup } from 'devextreme-react/popup';
import { LoadPanel } from 'devextreme-react/load-panel';
import { EditMemberForm } from '../members/edit-member-form';
import { AddMemberPopup } from './add-member-popup';
import { EditSchoolForm } from './edit-school-form';
import { CurrentSwitch } from '~/components/current-switch/current-switch';
import { calcGridHeight } from '~/helpers/ui';
import {
  CreateAuthorizedStore,
  CreateAuthorizedDataSource,
  loadMembersLookupDataAsync,
  disposeMembersLookupData,
} from '~/helpers/data';
import { appConst } from '~/app-const';
import { GridLayout } from '~/components/grid-layout-component/grid-layout';

const schoolsUrl = `${window.env.apiEndpoint}/api/v1/Schools`;
const membersUrl = `${window.env.apiEndpoint}/api/v1/Members`;

export class Schools extends Component {
  constructor(props) {
    super(props);

    this.toolbarItemRender = this.toolbarItemRender.bind(this);
    this.windowResized = this.windowResized.bind(this);

    this.dataSource = CreateAuthorizedDataSource(
      {
        loadUrl: `${schoolsUrl}/Get`,
        insertUrl: `${schoolsUrl}/Post`,
        updateUrl: `${schoolsUrl}/Put`,
        deleteUrl: `${schoolsUrl}/Delete`,
      }, null, 'Id',
    );

    this.state = {
      title: '',
      showEditForm: false,
      showMemberEditForm: false,
      showMemberAddNewForm: false,
      showLoadingPanel: false,
      addNewMode: false,
      memberAddNewMode: false,
      editFormPopupTitle : "Loading..."
    };

    this.editIconClick = this.editIconClick.bind(this);
    this.hideEditPopup = this.hideEditPopup.bind(this);
    this.hideMemberEditPopup = this.hideMemberEditPopup.bind(this);
    this.setShowMemberEditFormValue = this.setShowMemberEditFormValue.bind(this);
    this.hideMemberEditPopupAndRefreshGrid = this.hideMemberEditPopupAndRefreshGrid.bind(this);
    this.setShowMemberAddNewFormValue = this.setShowMemberAddNewFormValue.bind(this);
    this.hideEditPopupAndRefreshGrid = this.hideEditPopupAndRefreshGrid.bind(this);
    this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
    this.hideMemberAddNewPopupAndRefreshGrid = this.hideMemberAddNewPopupAndRefreshGrid.bind(this);
    this.showHideSchoolEditForm = this.showHideSchoolEditForm.bind(this);
    this.refreshSchoolGrid = this.refreshSchoolGrid.bind(this);
    this.getMemberPopupRef = this.getMemberPopupRef.bind(this);
    this.updateEditMemberPopupTitle = this.updateEditMemberPopupTitle.bind(this);

    this.editMemberFormRef = createRef();
    this.editMemberFormPopupRef = createRef();
    this.editSchoolFormRef = createRef();
    this.schoolsGridRef = createRef();
  }

  async componentDidMount() {
    window.addEventListener('resize', this.windowResized);
    this.setState({ membersLookupData: await loadMembersLookupDataAsync() });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResized);
    const { membersLookupData } = this.state

    membersLookupData && disposeMembersLookupData(this.state.membersLookupData);
  }

  windowResized() {
    this.schoolsGridRef.current.instance().option('height', calcGridHeight('schoolsGrid'));
  }

  toolbarItemRender() {
    return (
      <CurrentSwitch grid={this.schoolsGridRef} />
    );
  }

  editIconClick(key, name) {
    const getSchoolByIdStore = CreateAuthorizedStore(
      { loadUrl: `${schoolsUrl}/GetSchoolById` }, { load: { Id: key } },
    );
    getSchoolByIdStore.load().then(
      (result) => {
        this.setState({
          showEditForm: true,
          title: name,
          rowData: { ...result[0] },
          addNewMode: false,
        });
      },
    );
  }

  hideEditPopup() {
    this.setState({
      showEditForm: false,
    });
  }

  hideMemberEditPopup() {
    this.setState({
      showMemberEditForm: false,
    });
    this.schoolsGridRef.current.instance().option('loadPanel.enabled', false);
  }

  hideMemberAddNewPopup() {
    this.setState({
      showMemberAddNewForm: false,
    });
  }

  hideMemberEditPopupAndRefreshGrid() {
    this.hideMemberEditPopup();
    this.editSchoolFormRef.current.refreshGrids();
    this.refreshSchoolGrid();
  }

  hideEditPopupAndRefreshGrid(refresh) {
    this.hideEditPopup();
    if (refresh) { this.schoolsGridRef.current.instance().refresh(); }
  }

  setShowMemberEditFormValue(value, memberkey, memberAddNewMode) {
    if (!memberAddNewMode) {
      this.setState({ showLoadingPanel: true });
      const getMemberByIdStore = CreateAuthorizedStore(
        { loadUrl: `${membersUrl}/GetMemberById` }, { load: { Id: memberkey } },
      );
      // TODO: I see here a performance issue. The member edit popup form needs to wait
      // till we fetch the record from API. I do not know if load async would help.
      getMemberByIdStore.load().then(
        (result) => {
          this.setState({
            showMemberEditForm: value,
            rowMemberData: result[0],
            showLoadingPanel: false,
            memberAddNewMode,
          });
        },
      );
    } else {
      this.setState({
        showMemberEditForm: value,
        rowMemberData: { EmailAddresses: [], PhoneNumbers: [], Schools: [{ SchoolId: this.state.rowData.Id, Primary: true }] },
        memberAddNewMode,
      });
    }
  }

  setShowMemberAddNewFormValue(value) {
    this.setState({
      showMemberAddNewForm: value,
    });
  }

  hideMemberAddNewPopupAndRefreshGrid() {
    this.hideMemberAddNewPopup();
    this.editSchoolFormRef.current.refreshGrids();
  }

  showHideSchoolEditForm(value) {
    this.setState({
      showEditForm: value,
    });
  }

  refreshSchoolGrid() {
    this.schoolsGridRef.current.instance().refresh().then(
      () => {
        this.schoolsGridRef.current.instance().option('loadPanel.enabled', true);
      },
    );
  }

  renderEditPopup(isEditFormShown) {
    const { showEditForm, addNewMode, membersLookupData } = this.state;
    if (isEditFormShown) {
      return (
        <Popup
          visible={showEditForm}
          onHiding={(e) => {
            e.cancel = true;
            this.editSchoolFormRef.current.cancelData();
          }}
          {...appConst.defaultPopupOptions}
          title={this.state.title}
        >
          <EditSchoolForm
            ref={this.editSchoolFormRef}
            rowData={this.state.rowData}
            ridingsData={membersLookupData.ridingsData}
            provincesData={membersLookupData.provincesData}
            setShowMemberEditFormValue={this.setShowMemberEditFormValue}
            setShowMemberAddNewFormValue={this.setShowMemberAddNewFormValue}
            addNewMode={addNewMode}
            showHideSchoolEditForm={this.showHideSchoolEditForm}
            refreshSchoolGrid={this.refreshSchoolGrid}
          />
        </Popup>
      );
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'add',
        onClick: () => {
          this.setState({
            showEditForm: true,
            rowData: { Current: true },
            addNewMode: true,
            title: '(New School)',
          });
        },
      },
    });
  }

  getMemberPopupRef() {
    return this.editMemberFormPopupRef && this.editMemberFormPopupRef.current.instance();
  }

  updateEditMemberPopupTitle(newTitle) {
    this.setState({ editFormPopupTitle: newTitle || "Unable to show" });
  }

  renderMemberEditPopUp(isEditFormShown) {
    const { rowMemberData, membersLookupData, editFormPopupTitle } = this.state;
    if (isEditFormShown) {
      const { memberAddNewMode } = this.state;
      return (
        <Popup
          ref={this.editMemberFormPopupRef}
          visible={isEditFormShown}
          onHiding={(e) => {
            e.cancel = true;
            this.editMemberFormRef && this.editMemberFormRef.current.cancelData();
          }}
          {...appConst.defaultPopupOptions}
          title={editFormPopupTitle}
        >
          <EditMemberForm
            ref={this.editMemberFormRef}
            rowData={rowMemberData}
            hideEditPopupAndRefreshGrid={this.hideMemberEditPopupAndRefreshGrid}
            hideEditPopup={this.hideMemberEditPopup}
            salutationsData={membersLookupData.salutationsData}
            gendersData={membersLookupData.gendersData}
            pronounsData={membersLookupData.pronounsData}
            emailAddressTypesData={membersLookupData.emailAddressTypesData}
            phoneTypesData={membersLookupData.phoneTypesData}
            membershipTypesData={membersLookupData.membershipTypesData}
            employmentStatusesData={membersLookupData.employmentStatusesData}
            contractTypesData={membersLookupData.contractTypesData}
            ridingsData={membersLookupData.ridingsData}
            designationsData={membersLookupData.designationsData}
            addNewMode={memberAddNewMode}
            getMemberPopupRef={this.getMemberPopupRef}
            provincesData={membersLookupData.provincesData}
            updateTitle={this.updateEditMemberPopupTitle}
          />
        </Popup>
      );
    }
  }

  renderMemberAddNewPopUp(isEditFormShown) {
    if (isEditFormShown) {
      const { showMemberAddNewForm } = this.state;
      return (
        <AddMemberPopup
          showAddMemberPopup={showMemberAddNewForm}
          setShowMemberAddNewFormValue={this.setShowMemberAddNewFormValue}
          schoolId={this.state.rowData.Id}
          hideMemberAddNewPopupAndRefreshGrid={this.hideMemberAddNewPopupAndRefreshGrid}
          setShowMemberEditFormValue={this.setShowMemberEditFormValue}
        />
      );
    }
  }

  render() {
    const { showEditForm, showMemberEditForm, showMemberAddNewForm } = this.state;
    return (
      <>
        <div className="title">
          <span>Schools</span>
          <GridLayout
            layoutKey="Schools"
            gridName="schoolsGrid"
            pageName="SchoolsPage"
            gridRef={() => { return this.schoolsGridRef.current.instance() }}
          />
        </div>
        <LoadPanel
          visible={this.state.showLoadingPanel}
          showIndicator
          shading
          showPane
          hideOnOutsideClick={false}
        />
        {this.renderEditPopup(showEditForm)}
        {this.renderMemberEditPopUp(showMemberEditForm)}
        {this.renderMemberAddNewPopUp(showMemberAddNewForm)}
        <DataGrid
          id="schoolsGrid"
          ref={this.schoolsGridRef}
          dataSource={this.dataSource}
          {...appConst.defaultGridOptions}
          onToolbarPreparing={this.onToolbarPreparing}
          onRowDblClick={(e) => {
            this.editIconClick(e.key, e.data.Name);
          }}
          onInitialized={(e) => {
            e.component.option('height', calcGridHeight(e.component.element().id));
          }}
        >
          <Selection mode="multiple" />
          <SearchPanel
            visible
            width={240}
            placeholder="Search..."
          />
          <Scrolling
            mode="virtual"
            rowRenderingMode="virtual"
          />
          <Editing
            mode="popup"
            allowAdding={false}
            allowDeleting
            allowUpdating
          >
            <Popup showTitle title={this.state.title} />
          </Editing>
          <ColumnChooser
            enabled
            mode="dragAndDrop"
          />
          <Grouping
            allowCollapsing
            autoExpandAll={false}
            contextMenuEnabled
            expandMode="rowClick"
          />
          <GroupPanel
            visible
            allowColumnDragging
          />
          <HeaderFilter
            visible
            Search
          >
            <Search enabled={true} />
          </HeaderFilter>
          <Column
            dataField="Name"
            dataType="string"
            sortOrder="asc"
          />
          <Column dataField="PhoneNumber" dataType="string" />
          <Column dataField="FaxNumber" dataType="string" />
          <Column
            dataField="PrincipalName"
            dataType="string"
            cellRender={(data) => (
              <a href={`mailto:${data.row.data.PrincipalEmailAddress}`}>
                {data.row.data.PrincipalName}
              </a>
            )}
          />
          <Column
            dataField="PrincipalEmailAddress"
            dataType="string"
          />
          <FilterRow
            visible
          />
          <Column
            dataField="CommRepFullName"
            dataType="string"
            caption="Comm. Rep"
            cellRender={(data) => (
              <a href={`mailto:${data.row.data.CommRepEmailAddress}`}>
                {data.row.data.CommRepFullName}
              </a>
            )}
          />
          <Column
            dataField="CommRepEmailAddress"
            dataType="string"
            caption="Comm. Rep Email Address"
          />
          <Column dataField="Address1" dataType="string" visible={false} />
          <Column dataField="Address2" dataType="string" visible={false} />
          <Column dataField="Current" dataType="boolean" visible={false} />
          <Column dataField="ProvinceCode" dataType="string" visible={false} caption="Province" />
          <Column dataField="PostalCode" dataType="string" visible={false} />
          <Column dataField="EmailAddress" dataType="string" visible={false} />
          <Column dataField="Ward" dataType="numeric" visible={false} />
          <Column dataField="Riding" dataType="string" visible={false} />
          <Column dataField="TotalMemberCount" dataType="number" visible={false} />
          <Column dataField="RepsIdentified" dataType="number" visible={false} />
          <Column dataField="RepsEntitled" dataType="number" visible={false} />
          <Column dataField="DivCounts" dataType="string" visible={false} />
          <Column dataField="RouteNumber" dataType="string" visible={false} />
          <Column dataField="AddressVerified" visible={false}/>
          <Template name="switchCurrent" render={this.toolbarItemRender} />
          <Column
            dataField="CommRepPreferredFirstName"
            dataType="string"
            visible={false}
          />
          <Column
            dataField="CommRepFirstName"
            dataType="string"
            visible={false}
          />
          <Column
            dataField="CommRepLastName"
            dataType="string"
            visible={false}
          />
          <Column
            dataField="CommRepId"
            dataType="string"
            visible={false}
          />
          <Column
            dataField="StaffListReviewedByCommRep"
            dataType="date"
            visible={false}
            format={appConst.dateDisplayFormat}
          />
          <Column type="buttons">
            <Button name="edit" hint="Edit School" onClick={(e) => { this.editIconClick(e.row.key, e.row.data.Name); }} />
            <Button name="delete" hint="Delete School" />
          </Column>
        </DataGrid>
      </>
    );
  }
}
